import { EscrowMembershipRoleEnum } from 'src/graphql/schema';

export const permissionOptions = [
  {
    value: EscrowMembershipRoleEnum.Manager,
    label: 'Manager',
    description: 'Manages members on your side, plus settings, approvals, and change requests.',
  },
  {
    value: EscrowMembershipRoleEnum.Technical,
    label: 'Technical',
    description: 'Settings, approvals, and change requests.',
  },
  {
    value: EscrowMembershipRoleEnum.Legal,
    label: 'Legal',
    description: 'Settings, approvals, and change requests.',
  },
  {
    value: EscrowMembershipRoleEnum.Viewer,
    label: 'Viewer',
    description: 'Read-only access; can download the agreement.',
  },
];
